import { Icon, theme } from "@findemdev/maui";

// Styled components
import {
  NavigationTabsWrapper,
  NavigationTab,
  TabIconWrapper,
  TabText,
  TabDivider,
} from "./NavigationTabs.styled";

// Types
export enum TabId {
  'cred-library' = 'cred-library',
  'my-credentials' = 'my-credentials',
  'marquees' = 'marquees',
  'favorites' = 'favorites',
}

interface Tab {
  id: TabId;
  label: string;
  icon: string;
}

export const NAVIGATION_TABS: Tab[] = [
  {
    id: TabId['cred-library'],
    label: 'Cred Library',
    icon: 'layers',
  },
  {
    id: TabId['my-credentials'],
    label: 'My Credentials',
    icon: 'account_circle',
  },
  {
    id: TabId['marquees'],
    label: 'Marquees',
    icon: 'collections_bookmark',
  },
];

export const FAVORITES_TAB: Tab = {
  id: TabId['favorites'],
  label: 'Favorites',
  icon: 'star',
};

interface NavigationTabsProps {
  activeTab: TabId;
  onTabChange: (tabId: TabId) => void;
}

const NavigationTabs = ({ activeTab, onTabChange }: NavigationTabsProps) => {

  return (
    <NavigationTabsWrapper>
      {NAVIGATION_TABS.map((tab) => (
        <NavigationTab
          key={tab.id}
          $isActive={activeTab === tab.id}
          onClick={() => onTabChange(tab.id)}
        >
          <TabIconWrapper>
            <Icon
              icon={tab.icon}
              $size={20}
              $color={
                activeTab === tab.id
                  ? theme.colors['blue-400']
                  : theme.colors['grey-650']
              }
            />
          </TabIconWrapper>
          <TabText>{tab.label}</TabText>
        </NavigationTab>
      ))}
      <TabDivider />
      <NavigationTab
        $isActive={activeTab === FAVORITES_TAB.id}
        onClick={() => onTabChange(FAVORITES_TAB.id)}
      >
        <TabIconWrapper>
          <Icon
            icon={FAVORITES_TAB.icon}
            $size={20}
            $color={
              activeTab === FAVORITES_TAB.id
                ? theme.colors['blue-400']
                : theme.colors['grey-650']
            }
          />
        </TabIconWrapper>
        <TabText>{FAVORITES_TAB.label}</TabText>
      </NavigationTab>
    </NavigationTabsWrapper>
  );
};

export default NavigationTabs;
